module.exports = __webpack_public_path__ + "media/components/assets/recycling_02-fe14014acbdee42347523c8d916719fe.jpg";